import { orchestrator } from 'satcheljs';
import store from '../store/store';
import { updateMXRecords } from '../actions/updateMXRecords';
import {
    domainConnectFetchSetupInfoService,
    DomainPurchaseType,
    domainConnectCreateAndValidateLegacyDomainService,
} from 'owa-domain-connect';
import isDeprecateLegacyPremiumEnabled from '../utils/isDeprecateLegacyPremiumEnabled';

export default orchestrator(updateMXRecords, async function updateMXRecords() {
    if (
        isDeprecateLegacyPremiumEnabled() &&
        store.legacyPremiumTenant.TenantName &&
        store.legacyPremiumTenant.TenantName != '' &&
        (store.domainState.dnsRecordValue == '' || store.domainState.dnsRecordValue == null)
    ) {
        var resp = await domainConnectFetchSetupInfoService();
        var csrfToken = resp.csrfToken;
        await domainConnectCreateAndValidateLegacyDomainService(
            store.legacyPremiumTenant.TenantName,
            DomainPurchaseType.Existing,
            csrfToken
        );
    }
});
